import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=2f7ad389&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=ts"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=2f7ad389&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ad389",
  null
  
)

export default component.exports